import css from 'styled-jsx/css'

import { sizes, colors } from '../../theme'


export default css`
  .container {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    position: relative;
    align-items: flex-start;
    flex-direction: row;
    overflow: auto;
    width: 100%;
    max-width: ${sizes.body.tablet.maxWidth};
    margin: auto;
  }


  .container :global(.back-link) {
    display: flex;
    position: absolute;
    cursor: pointer;
    right: 3rem;
    top: 5rem;
  }

  .container :global(.back-link) a {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 150ms ease;
    text-decoration: none;
  }

  .separator {
    width: 100%;
    max-width: ${sizes.body.tablet.maxWidth};
    border-bottom: 2px solid ${colors.pureWhite};
    margin: 1rem auto auto auto;
  }


  @media screen and (min-width: ${sizes.media.tablet.endMaxWidth}) {
    .container :global(.back-link) a:hover {
        opacity: 0.6;
    }
    
    .container:hover :global(.back-link:hover ~ .route.selected .cloud) {
      opacity: 1;
      transform: scale(1) rotate(0deg);
    }
  
    .container:hover :global(.route:hover .cloud) {
      opacity: 1;
      transform: scale(1) rotate(0deg);
    }
  
    .container:hover :global(.route:not(:hover) .cloud) {
      opacity: 0;
      transform: scale(0) rotate(10deg);
    }  
  }
  

  .container :global(.back-link) a:active {
    opacity: 0.4;
  }

  .container :global(.back-link) a :global(img) {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .container {
      display: block;
    }

    .separator {
      width: calc(100% - 8rem);
      margin-left: 3rem;
    }
  

    .container :global(.back-link) {
      top: 3.4rem;
    }

    .container :global(.back-link) a {
      width: 3rem;
      height: 3rem;
    }
  }
`
